let styles = {
  container: {
    calculate: ({
      verticalBoundary,
      horizontalBoundary,
    }) => {
      let result = {
        position: 'fixed',
        zIndex: 9001,
        right: '24px',
      };

      result[verticalBoundary] = '24px';

      return result;
    },
  },
};

export default styles;
